const Loading = ()=>{
    return(
        <p>LOADING</p>
    )
}
export default Loading